import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'app-snack-bar-message',
  templateUrl: './snack-bar-message.component.html',
  styleUrls: ['./snack-bar-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIconModule],
})
export class SnackBarMessageComponent {
  snackBarRef = inject<MatSnackBarRef<SnackBarMessageComponent>>(MatSnackBarRef);
  data = inject<{
    message: string;
  }>(MAT_SNACK_BAR_DATA);

  close() {
    this.snackBarRef.dismissWithAction();
  }
}
